import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogoutButton } from "../Utility/AuthTokenRetrieve";
import "../Food/RecipeList.css";
import "./BabyTracker.css";
import {
  eventCategoryLabels,
  fetchBabySummary,
} from "./BabyTrackerShared";
import BabyTrackerLoading from "./BabyTrackerLoading";

const categoryLinks = [
  { label: "Diapers", to: "/baby-tracker/diapers", category: "diaper" },
  { label: "Feeding", to: "/baby-tracker/feeding", category: "feeding" },
  { label: "Pumping", to: "/baby-tracker/pumping", category: "pumping" },
  { label: "Frozen Milk", to: "/baby-tracker/frozen-milk", category: "frozenMilk" },
  { label: "Medicine", to: "/baby-tracker/medicine", category: "medicine" },
  { label: "Sleep", to: "/baby-tracker/sleep", category: "sleep" },
];

const BabyTrackerHome = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const refreshSummary = () => {
    setLoading(true);
    setLoadError("");
    fetchBabySummary()
      .then((data) => {
        setSummary(data);
        setLoading(false);
      })
      .catch(() => {
        setLoadError("Unable to load today's Baby Tracker counts.");
        setLoading(false);
      });
  };

  useEffect(() => {
    refreshSummary();
  }, []);

  const todayCounts = summary?.todayCounts || {};
  const medicineRemindersDue = summary?.medicineRemindersDue || [];
  return (
    <div className="BabyTrackerPage">
      <div className="searchBarDiv formViewWrapper BabyTrackerIntro">
        <div>
          <h2 className="BabyTrackerTitle">Baby tracker</h2>
          <p className="BabyTrackerSubtitle">
            Shared tracking for diapers, feeding, pumping, and medicine.
          </p>
        </div>
        <LogoutButton></LogoutButton>
      </div>

      <div className="BabyTrackerHomeImageWrap">
        <img className="BabyTrackerHomeImage" src="/lil_jon.jpeg" alt="Baby tracker" />
      </div>

      <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
        <div className="BabyTrackerTodayHeader">
          <h3>Today</h3>
          <Link className="BabyTrackerManageLink" to="/baby-tracker/medicine-reminders">
            Med reminders
          </Link>
        </div>
        {loadError ? <p className="BabyTrackerError">{loadError}</p> : null}
        {medicineRemindersDue.length ? (
          <div className="BabyTrackerInlineReminder">
            <strong>Medicine due</strong>
            <div className="BabyTrackerInlineReminderList">
              {medicineRemindersDue.map((reminder) => (
                <Link
                  className="BabyTrackerInlineReminderItem"
                  key={reminder.id}
                  to="/baby-tracker/medicine"
                >
                  {reminder.medicineName}
                </Link>
              ))}
            </div>
          </div>
        ) : null}
        <div className="BabyTrackerCategoryGrid">
          {categoryLinks.map((link) => (
            <Link
              className="summaryButton BabyTrackerCategoryButton"
              key={link.to}
              to={link.to}
            >
              <strong>{link.label}</strong>
              <span>
                {link.category === "sleep"
                  ? summary?.todaySleepLabel || "0m asleep"
                  : link.category === "frozenMilk"
                    ? `${summary?.frozenMilkTotalOunces || 0} oz stored`
                    : `${todayCounts[link.category] || 0} today`}
              </span>
            </Link>
          ))}
        </div>
        {summary?.todayFeedingOunces ? (
          <p className="BabyTrackerStatus">{summary.todayFeedingOunces} oz logged today.</p>
        ) : null}
        {summary?.todayPumpingOunces ? (
          <p className="BabyTrackerStatus">{summary.todayPumpingOunces} oz pumped today.</p>
        ) : null}
      </div>

      {loading ? (
        <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
          <BabyTrackerLoading label="Loading baby data" />
        </div>
      ) : null}

      <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
        <h3>Recent events</h3>
        {summary?.recentEvents?.length ? (
          summary.recentEvents.slice(0, 6).map((entry) => (
            <div className="BabyTrackerHistoryRow" key={entry.id}>
              <div>
                <strong>{entry.eventType}</strong>
                <div>{eventCategoryLabels[entry.eventCategory]}</div>
              </div>
              <span>{entry.occurredAt}</span>
            </div>
          ))
        ) : (
          <p>No baby events logged yet.</p>
        )}
      </div>
    </div>
  );
};

export default BabyTrackerHome;
